// src/components/ProtectedRoute.js
// Wraps a route and redirects to /Buscador if the user's role is not permitted.
// Usage in App.js:
//   <Route path='/Dashboard' element={
//     <ProtectedRoute allowedRoles={[ROLES.CLIENT_ADMIN]}>
//       <DashboardPage />
//     </ProtectedRoute>
//   } />
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.js';

const ProtectedRoute = ({ allowedRoles, children }) => {
    const { user } = useAuth();

    if (!allowedRoles.includes(user?.role)) {
        return <Navigate to="/Buscador" replace />;
    }

    return children;
};

export default ProtectedRoute;
